import { Minus, Plus } from "lucide-react";
import { fmt } from "@/lib/api";

const btn = "h-12 w-12 sm:h-14 sm:w-14 rounded-xl border flex items-center justify-center select-none transition-transform duration-100 active:scale-90 disabled:opacity-30";

export const Stepper = ({ value, onChange, min = 0, max = 10, step = 1, testid, tone = "blue", display }) => {
  const set = (v) => onChange(Math.min(max, Math.max(min, Math.round(v))));
  const empty = value == null;
  const toneCls = tone === "red" ? "border-red-500/40 bg-red-500/10 text-red-300" : "border-blue-500/30 bg-blue-500/10 text-blue-200";
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <button type="button" data-testid={`${testid}-minus`} className={`${btn} ${toneCls}`} disabled={empty || value <= min} onClick={() => set(value - step)}>
        <Minus className="w-5 h-5" />
      </button>
      <div data-testid={`${testid}-value`} className={`w-16 text-center font-display font-bold text-3xl tabular-nums ${empty ? "text-slate-600" : ""}`}>
        {empty ? "—" : display ? display(value) : fmt(value)}
      </div>
      <button type="button" data-testid={`${testid}-plus`} className={`${btn} ${toneCls}`} disabled={!empty && value >= max} onClick={() => set((value ?? 0) + step)}>
        <Plus className="w-5 h-5" />
      </button>
    </div>
  );
};

export const QuickPick = ({ value, onChange, testid }) => (
  <div className="grid grid-cols-11 gap-1 mt-2 sm:flex sm:flex-wrap">
    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
      <button
        key={n}
        type="button"
        data-testid={`${testid}-pick-${n}`}
        onClick={() => onChange(n)}
        className={`h-10 sm:h-8 min-w-0 sm:min-w-[2rem] px-0 sm:px-1 rounded-md text-xs sm:text-sm font-mono transition-colors duration-150 ${
          value === n ? "bg-blue-600 text-white" : "bg-white/5 text-slate-400 hover:bg-white/10 hover:text-white"
        }`}
      >
        {n}
      </button>
    ))}
  </div>
);
